// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  * {
    /* stylelint-disable-next-line declaration-no-important */
    text-shadow: none !important;
  }
  .vaJ6OQAMm3h1sW {
    display: none;
  }
}
.HbQt9QCUZrdgfH {
  overflow: hidden;
  transition: height 0.3s ease;
}
@media (prefers-reduced-motion: reduce) {
  .HbQt9QCUZrdgfH {
    transition: none;
  }
}
.Onskq_N6GSEfzP {
  display: none;
  position: fixed;
  z-index: 90;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  box-sizing: border-box;
  height: 0;
  transition: background-color 0.6s ease, height 0s linear 0.6s;
  background-color: var(--ds-UNSAFE-transparent, rgba(9, 30, 66, 0));
}
.Onskq_N6GSEfzP * {
  box-sizing: border-box;
  font-family: 'Charlie Text', var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
}
.Onskq_N6GSEfzP[data-open='true'] {
  height: 100vh;
  transition: background-color 0.6s ease, height 0s linear;
  background-color: var(--ds-background-neutral, rgba(9, 30, 66, 0.5));
  cursor: pointer;
}
@media (prefers-reduced-motion: reduce) {
  .Onskq_N6GSEfzP[data-open='true'] {
    transition: none;
  }
}
@media (min-width: 992px) {
  .Onskq_N6GSEfzP {
    display: block;
  }
}
@media (prefers-reduced-motion: reduce) {
  .Onskq_N6GSEfzP {
    transition: none;
  }
}
.YuC_pZjwHLBnTz {
  position: fixed;
  z-index: 100;
  top: var(--ds-space-0, 0);
  width: 100vw;
  transition: 0.5s background-color ease, 0.5s box-shadow ease;
  background-color: var(--ds-surface, #ffffff);
  box-shadow: var(--ds-shadow-overlay, 0px 8px 12px #091e4226, 0px 0px 1px #091e424f);
  cursor: default;
}
.YuC_pZjwHLBnTz:hover {
  box-shadow: var(--ds-shadow-raised, 0 8px 14px rgba(9, 30, 66, 0.15));
}
@media (prefers-reduced-motion: reduce) {
  .YuC_pZjwHLBnTz {
    transition: none;
  }
}
.HMwdF30vciJ95G {
  display: flex;
  align-items: stretch;
  height: 60px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noPrint": `vaJ6OQAMm3h1sW`,
	"detailWrapper": `HbQt9QCUZrdgfH`,
	"header": `Onskq_N6GSEfzP`,
	"innerHeader": `YuC_pZjwHLBnTz`,
	"navBar": `HMwdF30vciJ95G`
};
export default ___CSS_LOADER_EXPORT___;
